var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFbF(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 164.1 164.1",
    style: {
      enableBackground: "new 0 0 164.1 164.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#203162;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_14_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_113_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_16_",
    className: "st0",
    d: "M82.1,164.1C36.8,164.1,0,127.3,0,82.1S36.8,0,82.1,0s82.1,36.8,82.1,82.1 S127.3,164.1,82.1,164.1z M82.1,4C39,4,4,39,4,82.1c0,43,35,78.1,78.1,78.1c43,0,78.1-35,78.1-78.1C160.1,39,125.1,4,82.1,4z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_110_",
    className: "st0",
    d: "M100.2,46.6c0.3,0.7,0.9,1.3,1,2c0.1,3.3,0,6.5,0.1,9.8c0,1.4-0.6,2-2,2c-2.4,0-4.7,0-7.1,0.2 c-2.2,0.1-3.4,1.3-3.5,3.5c-0.1,2.7,0,5.3,0,8.2c3.2,0,6.3,0,9.5,0c2.5,0,2.8,0.2,2.8,2.8c0,3.2,0,6.3,0,9.5c0,1.9-0.4,2.3-2.3,2.3 c-3.2,0-6.5,0-9.9,0c0,0.7,0,1.2,0,1.8c0,8.9,0,17.8,0,26.6c0,0.8-0.6,1.7-0.9,2.5c-4.3,0-8.6,0-12.9,0c-1.1-0.5-1-1.5-1-2.4 c0-8.8,0-17.7,0-26.5c0-0.6,0-1.2,0-2c-3,0-5.7,0-8.5,0c-1.9,0-2.2-0.3-2.2-2.2c0-3.4,0-6.8,0-10.3c0-1.5,0.6-2.1,2.1-2.1 c2.8,0.1,5.7,0,8.7,0c0-3.1,0-6,0-8.9c0.2-9,5.4-15,14.3-16.4c0.2,0,0.4-0.2,0.6-0.2C92.4,46.6,96.3,46.6,100.2,46.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbF);
export default __webpack_public_path__ + "static/media/fb_f.9836cf6157cf93dea85bd02b8888393f.svg";
export { ForwardRef as ReactComponent };